import { createSlice, current } from "@reduxjs/toolkit";
import {
    history24, historyCustom, getReportList, downloadTrack,
    deleteReport, reportTtl, getExcel, getPdf, emailPdf
} from "./datacenterApi";
import randomcolor from 'randomcolor';


export const historySlice = createSlice({
    name: 'history',
    initialState: {
        reportIDs: [],
        trackData: {},
        visibleTracks: [],
        pinnedTracks: [],
        highlightedDrive: { startIndex: null, endIndex: null },
        highlightedStop: { startIndex: null },
        highlightedEvent: { routeIndex: null },
        trackDetailView: null,
        timeLineView: null,
        bottomView: 'trackList',
        trackPlayerIndex: 0,
        gensetTrackCache: {},
    },
    reducers: {
        setGensetTrackCache: (state, { payload }) => {
            const imei = payload?.imei;
            if (!imei) return state;
            state.gensetTrackCache[imei] = {
                reportId: payload.reportId,
                fetchedAt: payload.fetchedAt ?? Date.now(),
            };
            return state;
        },
        clearGensetTrackCache: (state, { payload }) => {
            if (!payload) {
                state.gensetTrackCache = {};
                return state;
            }
            if (state.gensetTrackCache[payload]) {
                delete state.gensetTrackCache[payload];
            }
            return state;
        },
        socketTrackBuilt: (state, { payload }) => {
            const { reportIDs, trackData } = sockTrackPusher(current(state.reportIDs), current(state.trackData), payload);
            state.reportIDs = reportIDs;
            state.trackData = trackData;
            return state;
        },
        addToPinnedTracks: (state, { payload }) => {
            state.pinnedTracks = state.pinnedTracks.indexOf(payload) === -1
                ? [...state.pinnedTracks, payload]
                : state.pinnedTracks;
            state.visibleTracks = state.visibleTracks.indexOf(payload) === -1
                ? [...state.visibleTracks, payload]
                : state.visibleTracks;
            return state;
        },
        removefromPinnedTracks: (state, { payload }) => {
            state.pinnedTracks = state.pinnedTracks.indexOf(payload) !== -1
                ? state.pinnedTracks.filter(a => a !== payload)
                : state.pinnedTracks;
            state.visibleTracks = state.visibleTracks.indexOf(payload) !== -1
                ? state.visibleTracks.filter(a => a !== payload || a === state.trackDetailView)
                : state.visibleTracks;
            return state;
        },
        addToVisisbleTracks: (state, { payload }) => {
            state.visibleTracks = state.visibleTracks.indexOf(payload) === -1
                ? [...state.visibleTracks, payload]
                : state.visibleTracks;
            return state;
        },
        removefromVisibleTracks: (state, { payload }) => {
            state.visibleTracks = state.visibleTracks.indexOf(payload) !== -1
                ? state.visibleTracks.filter(a => a !== payload)
                : state.visibleTracks;
            return state;
        },
        removeAllFromVisibleTracks: (state) => {
            state.visibleTracks = [];
            return state;
        },
        setTrackColor: (state, { payload }) => {
            state.trackData[payload.reportID].color = payload.color;
            return state;
        },
        setTrackDetailView: (state, { payload }) => {
            if (payload !== null) {
                if (payload !== state.trackDetailView) {
                    state.visibleTracks = state.pinnedTracks;
                }
                state.trackDetailView = payload;
                state.visibleTracks = state.visibleTracks.indexOf(payload) === -1
                    ? [...state.visibleTracks, payload]
                    : state.visibleTracks;
            } else {
                state.trackDetailView = null;
                state.visibleTracks = state.pinnedTracks;
            }

            //console.log("track detail reducer", payload);
            return state;
        },
        setTimeLineView: (state, { payload }) => {
            state.timeLineView = payload;
            return state;
        },
        setbottomView: (state, { payload }) => {
            state.bottomView = payload;
            if (payload === 'trackList') {
                state.highlightedDrive = { startIndex: null, endIndex: null };
            }
            return state;
        },
        setHighlightedDrive: (state, { payload }) => {
            state.highlightedDrive = payload;
            state.highlightedStop = { startIndex: null };
            state.highlightedEvent = { routeIndex: null };
            return state;
        },
        removeHighlightedDrive: (state) => {
            state.highlightedDrive = { startIndex: null, endIndex: null };
            return state;
        },
        setHighlightedStop: (state, { payload }) => {
            state.highlightedStop = payload;
            state.highlightedDrive = { startIndex: null, endIndex: null };
            state.highlightedEvent = { routeIndex: null };
            return state;
        },
        removeHighlightedStop: (state) => {
            state.highlightedStop = { startIndex: null };
            return state;
        },
        setHighlightedEvent: (state, { payload }) => {
            state.highlightedEvent = payload;
            state.highlightedDrive = { startIndex: null, endIndex: null };
            state.highlightedStop = { startIndex: null };
            return state;
        },
        removeHighlightedEvent: (state) => {
            state.highlightedEvent = { routeIndex: null };
            return state;
        },
        setTrackPlayerIndex: (state, { payload }) => {
            state.trackPlayerIndex = payload;
            return state;
        }
    },
    extraReducers: {
        [getReportList.fulfilled]: (state, { payload }) => {
            //console.log("List", payload);
            const { reportIDs, trackData } = trackListBuild(current(state.reportIDs), current(state.trackData), payload);
            state.reportIDs = reportIDs;
            state.trackData = trackData;
            //console.log("tracklist updated", reportIDs.length);
            return state;

        },
        [downloadTrack.fulfilled]: (state, { payload }) => {
            //console.log("Route download", payload);
            if (payload.reportData.reportRecords.length > 0) {
                state.trackData[payload.reportID].dataTable = true;
                state.trackData[payload.reportID] = {
                    ...state.trackData[payload.reportID],
                    ...payload.reportData
                };
            }
            return state;
        },
        [deleteReport.fulfilled]: (state, { payload }) => {
            //console.log("delete opayload", payload);
            const { reportIDs, trackData } = deleteReportData(current(state.reportIDs), current(state.trackData), payload.reportID);
            state.reportIDs = reportIDs;
            state.trackData = trackData;
            return state;
        },
        [historyCustom.fulfilled]: (state, { payload }) => {
            payload.forEach(p => {
                const { reportIDs, trackData } = sockTrackPusher(state.reportIDs, state.trackData, p);
                state.reportIDs = reportIDs;
                state.trackData = trackData;
            })
            return state;
        },
        [history24.fulfilled]: (state, { payload }) => {
            if (payload) {
                const { reportIDs, trackData } = sockTrackPusher(state.reportIDs, state.trackData, payload);
                state.reportIDs = reportIDs;
                state.trackData = trackData;
            }
            return state;
        }
    }
})

export {
    history24, historyCustom, getReportList, downloadTrack,
    deleteReport, reportTtl, getExcel, getPdf, emailPdf
};

export const {
    socketTrackBuilt,
    addToVisisbleTracks, removefromVisibleTracks, removeAllFromVisibleTracks,
    setTrackDetailView, setTimeLineView, setbottomView,
    setHighlightedDrive, removeHighlightedDrive, setHighlightedStop,
    removeHighlightedStop, setHighlightedEvent, removeHighlightedEvent,
    addToPinnedTracks, removefromPinnedTracks,
    setTrackPlayerIndex,
    setGensetTrackCache, clearGensetTrackCache,
} = historySlice.actions;

export const reportIDsSelector = state => state.history.reportIDs;
export const trackDataSelector = state => state.history.trackData;
export const visibleTracksSelector = state => state.history.visibleTracks;
export const trackDetailViewSelector = state => state.history.trackDetailView;
export const timeLineViewSelector = state => state.history.timeLineView;
export const bottomViewSelector = state => state.history.bottomView;
export const highlightedDriveSelector = state => state.history.highlightedDrive;
export const highlightedStopSelector = state => state.history.highlightedStop;
export const highlightedEventSelector = state => state.history.highlightedEvent;
export const pinnedTracksSelector = state => state.history.pinnedTracks;
export const trackPlayerIndexSelector = state => state.history.trackPlayerIndex;
export const gensetTrackCacheSelector = state => state.history.gensetTrackCache || {};

function deleteReportData(list, data, reportID) {
    let reportIDs = [...list];
    let trackData = { ...data };

    reportIDs = reportIDs.filter(a => a !== reportID);
    trackData[reportID] = null;
    return { reportIDs, trackData };
}

function trackListBuild(list, data, tracks) {
    let reportIDs = [...list];
    let trackData = { ...data };
    //console.log("trtack trackListBuild", tracks);
    if (tracks.length > 0) {
        tracks.forEach(track => {
            const { reportID, reportType } = track;
            if (reportType === 'track') {
                //console.log("trackids", reportIDs, reportID);
                if (reportIDs.indexOf(reportID) === -1) {
                    reportIDs.push(reportID);
                }
                trackData = {
                    ...trackData,
                    [reportID]: {
                        trackColor: randomcolor({ luminosity: 'bright', hue: 'blue' }),
                        ...trackData[reportID],
                        ...track,
                    },
                };
            }

        })
    }
    reportIDs = sortTrackIDs(reportIDs, trackData);
    //console.log("tracklist updated", reportIDs.length);
    return { reportIDs, trackData };
}

function sockTrackPusher(list, data, trackSummary) {
    let reportIDs = [...list];
    let trackData = { ...data };

    const { reportID, reportType } = trackSummary;
    if (reportType === 'track') {
        if (reportIDs.indexOf(reportID) === -1) {
            reportIDs.push(reportID);
        }
        trackData = {
            ...trackData,
            [reportID]: {
                trackColor: randomcolor({ luminosity: 'bright', hue: 'blue' }),
                ...trackData[reportID],
                ...trackSummary,
            },
        };
    }
    reportIDs = sortTrackIDs(reportIDs, trackData);
    return { reportIDs, trackData };
}

function sortTrackIDs(list, content) {
    list.sort(function (a, b) {
        const keyA = content[`${a}`].reqTime;
        const keyB = content[`${b}`].reqTime;
        return keyB - keyA;

    });
    return list;
}
